import { usePracticeBannerData } from './PracticeBannerProvider.graphql';
import { PracticeBanner } from '@orthly/veneer';
import React from 'react';

export const PracticeTopBanner: React.VFC = () => {
    const { banner } = usePracticeBannerData();

    return <PracticeBanner banner={banner} />;
};
